var show_error = false;
$(function() {

  $('.colorpickerinstance .colorpickerblock').click(function(e) {
    	var picker = $(this).parents('.colorpickerinstance').index()
  		var color = $(this).data('color');
   		var item = picker + 1;
		console.log('input[data-value="'+color+'"]');
		//var target = $('input[data-value="'+color+'"]');
		var target = $('input[value="'+color+'"');
		target.trigger("click");
		console.log(target);
		$('fieldset[name="Color"').parent().hide();
    	$('.colorpickerblock').removeClass('selected');
    	$('#color' + item).val(color);
    	$('#colorname' + item).text(color);
    	$(this).addClass("selected");
    	//console.log(color);
    
  });
  
  
  //FORCE ALL PICKERS TO DEFAULT TO BLACK
  $('[data-color="Black"]').each(function() {
    $(this).trigger("click");
  });
}); 